import styled from "@emotion/styled";
import { Col } from "antd";
import { genericStyles } from "../../../constant";

export const StyledChatView = styled(Col)`
  border-left: 1px solid #e5e7eb;
  border-right: 1px solid #e5e7eb;
  background: #f9fafb;
  height: 100%;
  .right-panel {
    height: 100%;
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    transition:
      flex 0.35s cubic-bezier(0.4, 0, 0.2, 1),
      max-width 0.35s cubic-bezier(0.4, 0, 0.2, 1);

    .chat-header {
      padding: 16px;
      background: ${genericStyles.primaryColor};
      border-bottom: 1px solid #e5e7eb;

      .header-left {
        .back-button {
          font-size: 22px;
          color: white;
          margin-left: -10px;
        }
        flex: 1;
        min-width: 0;
        .avatar {
          margin-left: 3px;
          margin-right: 12px;
          color: ${genericStyles.primaryColor};
          background: white !important;
        }
      }

      .customer-info {
        flex: 1;
        min-width: 0;
        color: white;
        font-weight: 400;
        font-size: 15px;
      }

      .header-actions {
        display: flex;
        align-items: center;
        gap: 0px;
        .action-btn {
          .anticon {
            color: white;
            font-size: 20px;
            font-weight: bold;
          }
        }
      }
    }

    .messages-area {
      flex: 1;
      overflow-y: auto;
      padding: 10px;
      display: flex;
      flex-direction: column;
      gap: 16px;

      background-image: linear-gradient(
        180deg,
        rgba(229, 228, 243, 0.65) 0%,
        rgba(220, 232, 234, 0.65) 100%
      );
      .message-body {
        flex: 1;
      }

      &::-webkit-scrollbar {
        width: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background: #d1d5db;
        border-radius: 2px;
      }

      .own-message {
        .message-body {
          justify-content: end;
        }
        .message-bubble {
          border-top-left-radius: 10px !important;
          border-top-right-radius: 0px !important;
          background: #20cb651a !important;
          border: 1px solid #20cb6449 !important;
        }
        .message-content {
          color: #14532d !important;
        }
        .message-reactions-div {
          left: -35px !important;
          right: 0px !important;
        }
      }
      .system-message {
        .message-bubble {
          background-color: #f3f4f6 !important;
          border: 1px solid #d1d5db;
          margin-left: 8px;
        }
        .message-content {
          color: #374151 !important;
        }
      }
      .message-wrapper {
        display: flex;
        animation: fadeSlideIn 0.5s ease-out;

        @keyframes fadeSlideIn {
          from {
            opacity: 0;
            transform: translateY(8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .message-avatar {
          font-size: 14px !important;
        }
        .message-bubble {
          display: flex;
          flex-direction: column;
          background: var(--selected);
          padding: 6px 8px;
          max-width: 85%;
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
          border-top-left-radius: 0px;
          border-top-right-radius: 10px;
          position: relative;
        }

        :hover .message-reactions-div {
          display: flex !important;
        }
        .message-reactions-div {
          position: absolute;
          right: -35px;
          top: 0;
          bottom: 0;
          display: none;
          align-items: center;
          width: 30px;
          .reaction-button {
            font-size: 22px;
          }
        }

        .message-sender {
          font-size: 13px;
          font-weight: 500;
          color: var(--primary);
          margin-bottom: 2px;
        }

        .sender-with-file {
          margin-bottom: 8px !important;
        }

        .message-content {
          font-size: 15px;
          font-weight: 400;
          word-wrap: break-word;
          white-space: pre-wrap;
          color: #1f1f1f; /* Dark gray for main message text */
          line-height: 1.4;
          word-break: break-word;
        }

        .message-content a {
          pointer-events: all;
          position: relative;
          z-index: 1;
        }

        .message-image-content {
          width: min-content;
          min-width: 100%;
        }

        .message-time {
          font-size: 10px;
          font-weight: 500;
          text-align: end;
          margin-top: 2px;
          color: #6b7280; /* Muted gray for timestamp */
        }
        .attachment-container {
          margin-bottom: 4px;
        }

        .video-attachment {
          video {
            width: auto;
            max-height: 30dvh;
            border-radius: 8px;
            max-width: 100%;
          }
        }
        .audio-player {
          max-width: 100%;
        }

        .image-preview {
          text-align: end;
          position: relative;
          overflow: hidden;
          cursor: pointer;
          border-radius: 8px;
          img {
            width: auto;
            max-height: 30dvh;
            max-width: 100%;
            display: block;
            object-fit: cover;
            border-radius: 8px;
          }

          &:hover .download-overlay {
            opacity: 1;
          }
        }

        .download-overlay {
          position: absolute;
          top: 8px;
          right: 8px;
          background: rgba(0, 0, 0, 0.6);
          border-radius: 50%;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.2s;
          cursor: pointer;

          &:hover {
            background: rgba(0, 0, 0, 0.8);
          }
        }

        .download-icon {
          color: white;
          font-size: 18px;
        }

        .file-attachment {
          display: flex;
          align-items: center;
          gap: 12px;
          background: rgba(255, 255, 255, 0.5);
          padding: 12px;
          border-radius: 8px;
          cursor: pointer;
          transition: background 0.2s;

          &:hover {
            background: rgba(255, 255, 255, 0.8);
          }
        }

        .file-icon {
          font-size: 30px;
          flex-shrink: 0;
        }

        .file-info {
          flex: 1;
        }

        .file-name {
          font-size: 14px;
          font-weight: 400;
          color: #1f1f1f;
          word-wrap: break-word;
          white-space: pre-wrap;
          word-break: break-word;
        }

        .file-size {
          font-size: 12px;
          color: #6b7280;
          margin-top: 2px;
        }

        .download-button {
          width: 34px !important;
          height: 34px !important;
          min-width: 34px !important;
          background: transparent;
          border: 1px solid ${genericStyles.primaryColor};
          font-size: 20px;
          color: ${genericStyles.primaryColor};
        }

        .reactions-bar {
          margin-top: 4px;

          .reaction-bubble {
            padding: 5px;
            background: #f0f2f5;
            border-radius: 5px;
            cursor: pointer;
            max-width: fit-content;
          }

          .reaction-emoji {
            font-size: 14px;
            line-height: 1;
            padding: 0px 2px;
          }

          .reaction-count {
            padding-left: 3px;
            font-size: 14px;
            color: #667781;
            font-weight: 400;
          }
        }
      }
    }

    .empty-view {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;

      .ant-empty {
        .ant-empty-description {
          color: #6b7280;
        }
      }
    }
  }
  .ticket-container {
    transition:
      flex 0.35s cubic-bezier(0.4, 0, 0.2, 1),
      max-width 0.35s cubic-bezier(0.4, 0, 0.2, 1);

    padding: 0 20px;
    .ticket-header {
      height: 73px;
      h2 {
        font-weight: 500 !important;
      }
      h4 {
        margin: 0 !important;
      }
    }
    .info-body {
      height: calc(100% - 76px);
      overflow-y: auto;
    }
    .info-section {
      margin-bottom: 16px;
      .header {
        margin-bottom: 10px;
      }

      .section-title {
        display: block;
        margin-bottom: 12px;
        font-size: 16px;
        color: #262626;
        strong {
          font-weight: 500 !important;
        }
      }

      .info-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;
        padding: 4px 0;

        .info-label {
          font-size: 13px;
          min-width: 100px;
        }

        .info-value {
          font-size: 13px;
          color: #595959;
          text-align: right;
          word-break: break-all;
        }

        .priority-tag {
          margin: 0;
          font-size: 11px;
          padding: 1px 6px;
          border-radius: 10px;
        }
      }
    }

    .members-list {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .member-item {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 12px;
      border-radius: 8px;
      transition: background 0.2s ease;
      .anticon {
        font-size: 18px;
      }
    }

    .member-item:hover {
      background: #f5f5f5;
    }

    .member-details {
      flex: 1;
      min-width: 0;
    }

    .member-name {
      font-size: 15px;
      font-weight: 500;
      color: #262626;
      margin-bottom: 4px;
    }

    .member-email {
      font-size: 12px;
      color: #8c8c8c;
    }

    .member-item:hover .delete-member-btn {
      opacity: 1;
    }
  }
`;

export const StyledPopoverContent = styled.div`
  display: flex;
  gap: 5px;

  .reaction-span {
    font-size: 24px;
    cursor: pointer;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition:
      transform 0.2s ease,
      box-shadow 0.2s ease,
      background-color 0.2s ease;

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    &.selected {
      background-color: rgba(0, 0, 0, 0.1);
      transform: scale(1.1);
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    }
  }
`;
